import React from 'react'
import { Mutation } from "react-apollo";
import { DELETE,GET_BY_ID } from "../../../queries/pushNotification";
import DeleteIcon from '@material-ui/icons/Delete';
import { IconButton } from '@material-ui/core';

function filteredData(s, l, ls){
  s.data.forEach(d => {
    const id = ls[d.dataIndex].id;
      l = l.filter(e => e.id !== id)
    })
  return l;
}

class Delete extends React.Component {
  render(){
    const { selectedRows, messages } = this.props;
    return (
      <Mutation
        mutation={DELETE}
        update={(store, { data: { deleteMessage } }) => {
          const { messages } = store.readQuery({ query: GET_BY_ID, variables: { publisherId: localStorage.getItem('publisher-active')} });
          store.writeQuery({
            query: GET_BY_ID,
            variables: { publisherId: localStorage.getItem('publisher-active')},
            data: { messages: filteredData(selectedRows, messages, messages) }
          });
        }}
        >
        {deleteMessage => (
          <div>
            <IconButton aria-label="delete" onClick = {
              e => {
                e.preventDefault();
                selectedRows.data.forEach(d => {
                  const id = messages[d.dataIndex].id;
                  deleteMessage({ variables: {id: id }})  
                });
              }
            }>
              <DeleteIcon />
            </IconButton>
          </div>
        )}
      </Mutation>
    );
  }
};

export default Delete;